export default {
  path: '/login',
  name: 'login',
  component: () => import(/* webpackChunkName: "login" */ '@/views/login'),
  meta: { requiresAuth: false },
}